import React, { useEffect, useState } from "react";
import "./SideBarTabContent.scss";
import JobDetails from "./JobDetails/JobDetails";
import AssessmentsDetails from "./Assessments/AssessmentsDetails";
import TabsFilter from "./TabsFilter/TabsFilter";
import { useTranslation } from "react-i18next";
import UploadFilePopup from "../../../UploadFilePopup/UploadFilePopup";
import {
  companyGetJobDetails,
  cvList,
  getSkillsForLevels,
  getSourcesList,
  jobAssessmentList,
  scanCVs,
  systemCVRefreshStatus,
  uploadedCVCount,
} from "../../../../../service/CvScanning/CvScanning";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import DetailsPageWrapper from "../DetailsPageWrapper";
import {
  AssessmentButton,
  JobCvList,
  useClickOutsideListenerRef,
} from "ui-components";
import {
  capitalizeFirstLetter,
  foundUniqueId,
  scrollWindowTop,
} from "../../../../../utils/Common/Constant";
import CvJobDetailsIcon from "../../../../../utils/Images/CvJobDetailsIcon";
import CvAssessmentTabIcon from "../../../../../utils/Images/CvAssessmentTabIcon";
import CvSourceIcon from "../../../../../utils/Images/CvSourceIcon";
import CvIcon from "../../../../../utils/Images/CvIcon";
import SourceList from "./TabsFilter/Sourcing/SourceList/SourceList";
import useDebounce from "../../../../../utils/Hooks/useDebounce";
import { setSessionStorageItem } from "../../../../../utils/SessionStorageMethod/setSessionStorageItem";
import { getSessionStorageItem } from "../../../../../utils/SessionStorageMethod/getSessionStorageItem";
import { deleteAssessmentTempData } from "../../../../../service/Scope/Scope";
import Vendors from "./Vendors/Vendors";
import VendorsIcon from "../../../../../utils/Images/VendorsIcon";
// import { getJobPartnersList } from "../../../../../service/StaffAugumentation/StaffAugumentationApis";
import MoreIcon from "../../../../../utils/Images/MoreIcon";
import NoAssessmentImage from "../../../../../utils/Images/NoAssessmentImage";
import SelfIcon from "../../../../../utils/Images/SelfIcon";
import { JobScreensEnums } from "../../../../../utils/Enums/JobScreensEnums";
import { SettingAppEnums } from "../../../../../utils/Enums/SettingAppEnums";
type FileProgress = {
  file: File;
  progress: number;
  status: "uploading" | "completed" | "failed";
};

const SideBarTabContent: React.FC = () => {
  const { t, i18n } = useTranslation();
  const currentLanguage = i18n.language;
  const { jobId }: any = useParams();
  const navigate = useNavigate();
  const [cvCountLoader, setCvCountLoader] = useState(true);
  const [cvCounts, setCvCounts] = useState<any>(null);
  const [searchParams, setSearchParams] = useSearchParams();
  const [cvScanData, setCvScanData] = useState([]);
  const [fileProgressList, setFileProgressList] = useState<FileProgress[]>([]);
  const [activeAssessment, setActiveAssessment] = useState<string | null>(
    searchParams.get("assessmentId") || "",
  );
  const [activeAssessmentData, setActiveAssessmentData] = useState<any>({});
  const [assessmentDetailsData, setAssessmentDetailsData] = useState([]);
  const [isConfirmScanCvs, setIsConfirmScanCvs] = useState(false);
  const [jobDetailsData, setJobDetailsData] = useState<any>({});
  const [matchedSkills, setMatchedSkills] = useState<any>([]);
  const [searchCv, setSearchCv] = useState(searchParams.get("search") || "");
  const searchCvDelay = useDebounce(searchCv.trim(), 700);
  const [currentPage, setCurrentPage] = useState(1);
  const [cvListData, setCvListData] = useState([]);
  const [loadingCvList, setLoadingCvList] = useState(true);
  const [totalCvListData, setTotalCvListData] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [jobPartners, setJobPartners] = useState([]);
  const [venderTabId, setVenderTabId] = useState(
    searchParams.get("vendorId") || "",
  );
  const [showOverlay, setShowOverlay] = useState(false);
  const overlayRef = useClickOutsideListenerRef(() => setShowOverlay(false));
  const [isInviteVendorOpen, setIsInviteVendorOpen] = useState(false);
  const [jobDetailsTab, setJobDetailsTab] = useState<string>(
    searchParams.get("at") || JobScreensEnums.TAB_JOB_DETAILS,
  );
  const [selectedSourceType, setSelectedSourceType] = useState<string>(
    searchParams.get("filter") || JobScreensEnums.STATUS_ALL,
  );
  const [isfilterColumns, setIsFilterColumns] = useState<any>(
    searchParams.get("sort") || "overAll",
  );
  const [isDirectionArrow, setIsDirectionArrow] = useState<any>(
    searchParams.get("order") || "desc",
  );
  const [scoreCalculationSideBar, setScoreCalculationSideBar] = useState(
    searchParams.get("showFormulaPopup") || null,
  );
  const [isInvitedPopup, setIsInvitedPopup] = useState(
    searchParams.get("cvId") || "",
  );
  const [cvStatus, setCvStatus] = useState(
    searchParams.get("cvStatus") || "all",
  );
  const [vendorSortBy, setVendorSortBy] = useState<any>(
    searchParams.get("vendorSortBy") || "",
  );
  const [vendorSortOrder, setVendorSortOrder] = useState<any>(
    searchParams.get("vendorSortOrder") || "",
  );
  const [contractDocPopup, setContractDocPopup] = useState(
    searchParams.get("reviewDoc") ?? null,
  );
  const [showDocument, setShowDocument] = useState(
    searchParams.get("reviewVendorDoc") ?? null,
  );

  const [refreshRequired, setRefreshRequired] = useState(false);
  const [loading, setLoading] = useState(false);
  const [sourceType, setSourceType] = useState<any>([]);
  const [hasInProgress, setHasInProgress] = useState(false);
  const [referenceSourceType, setReferenceSourceType] = useState<any>([]);
  const [showSortMenu, setShowSortMenu] = useState(false);
  const licenseWithStatus = JSON.parse(
    localStorage.getItem("licenseWithStatus") ?? "[]",
  );
  const isStaffAugEnabled = licenseWithStatus?.some(
    (item: any) =>
      item["license.name"] === SettingAppEnums.LICENSE_STAFF_AUGMENTATION &&
      item.isEnabled === true,
  );
  const assessmentDetailsFuncData = async (jobId: string) => {
    const assessRes = await jobAssessmentList(jobId);
    if (assessRes?.status === 200) {
      setAssessmentDetailsData(assessRes?.data);
      setActiveAssessmentData(
        assessRes?.data?.find(
          (item: any) => item?.assessmentId === activeAssessment,
        ),
      );
    }
  };
  const handleActiveTab = (tabName: any) => {
    setJobDetailsTab(tabName);
    setLoadingCvList(false);
  };
  // Handle URL updates when filters or tabs change
  useEffect(() => {
    const params: Record<string, string> = { at: jobDetailsTab };
    if (
      jobDetailsTab === JobScreensEnums.TAB_SELF ||
      jobDetailsTab === JobScreensEnums.TAB_APPLICATIONS ||
      jobDetailsTab === JobScreensEnums.TAB_VENDOR
    ) {
      params.search = searchCvDelay || "";
      params.filter = selectedSourceType;
      params.sort = cvStatus === "unscanned" ? "uploadedDate" : isfilterColumns;
      params.order = isDirectionArrow;
      params.cvStatus = cvStatus;
      params.vendorSortBy = vendorSortBy;
      params.vendorSortOrder = vendorSortOrder;
      params.vendorId = venderTabId || "";
      if (isInvitedPopup) {
        params.cvId = isInvitedPopup || "";
      }
      if (scoreCalculationSideBar) {
        params.showFormulaPopup = scoreCalculationSideBar || "";
      }
    }
    if (jobDetailsTab === JobScreensEnums.TAB_ASSESSMENTS) {
      params.assessmentId = activeAssessment || "";
    }
    if (contractDocPopup) {
      params.reviewDoc = contractDocPopup.toString();
    }
    if (showDocument) {
      params.reviewVendorDoc = showDocument.toString();
    }
    setSearchParams(params, { replace: true });
  }, [
    jobDetailsTab,
    selectedSourceType,
    isfilterColumns,
    isDirectionArrow,
    searchCvDelay,
    cvStatus,
    vendorSortBy,
    vendorSortOrder,
    venderTabId,
  ]);
  const getCVCounts = async () => {
    const updateCountRes = await uploadedCVCount(
      jobId,
      vendorSortBy,
      vendorSortOrder,
    );
    if (updateCountRes?.status === 200) {
      setCvCounts(updateCountRes?.data);
      setJobPartners(updateCountRes?.data?.vendorsCVs || []);
      setCvCountLoader(false);
    }
  };
  // Initialize filters from URL when component loads
  useEffect(() => {
    const sourceTypeFromUrl = searchParams.get("filter");
    if (sourceTypeFromUrl) {
      setSelectedSourceType(sourceTypeFromUrl);
    }
  }, [searchParams]);
  useEffect(() => {
    getCVCounts();
  }, [vendorSortBy, vendorSortOrder]);
  useEffect(() => {
    const getJobDetails = async () => {
      const jobDetailsRes = await companyGetJobDetails(jobId);
      if (jobDetailsRes?.status === 200) {
        setJobDetailsData(jobDetailsRes?.data);
        assessmentDetailsFuncData(jobDetailsRes?.data?.jobId);
        const extractedSkillIds = jobDetailsRes?.data?.jobSkills
          .map((item: any) => item?.skillId)
          .filter((id: string | null | undefined) => id != null);
        const skillIdsArray = JSON.stringify(extractedSkillIds);
        // api call to get difficulty levels present in given skillId array
        const getSkillsLevel = await getSkillsForLevels([skillIdsArray]);
        // here merged both array jobDetailsRes and getSkillsLevel so that get jobSkillId and other details
        const mergedSkills = jobDetailsRes?.data?.jobSkills
          .filter((jobSkill: any) => jobSkill.skillId !== null)
          .map((jobSkill: any) => {
            const skillDetail = getSkillsLevel?.data?.data?.find(
              (skill: any) => skill.skillId === jobSkill.skillId,
            );
            if (skillDetail) {
              return {
                ...jobSkill,
                ...skillDetail,
              };
            }
            return null;
          })
          .filter((item: any) => item !== null);
        // created customize object to show skill cards with available difficulty levels
        const updatedSkills = mergedSkills.map((skill: any, ind: number) => {
          const levelsArray = skill?.difficultyLevels?.split(",");
          const selectedDifficultyLevels = levelsArray?.reduce(
            (acc: { [x: string]: number }, level: string) => {
              acc[level.trim()] = 1;
              return acc;
            },
            {},
          );
          return {
            jobSkillId: skill.jobSkillId,
            skillName: skill.skillName,
            skillId: skill.skillId,
            questionType: skill.questionType,
            totalQuestions: skill.totalQuestions,
            questionNo: Object.keys(selectedDifficultyLevels)?.length,
            difficultyLevels: skill.difficultyLevels,
            type: "template",
            selectedDifficultyLevels,
            questionCount: Object.keys(selectedDifficultyLevels)?.length,
            id: Math.random() + ind,
            icon: skill?.icon,
          };
        });
        setMatchedSkills(updatedSkills);
      }
    };
    getJobDetails();
    handleSystemCvRefresh();
    getSourcesListApi();
  }, []);

  // get source list
  const getSourcesListApi = async () => {
    try {
      if (!jobId) {
        console.error("jobId is required to fetch the sources list.");
        return;
      }
      const res = await getSourcesList(jobId);
      const defaultData = [
        {
          label: JobScreensEnums.STATUS_ALL,
          value: JobScreensEnums.STATUS_ALL,
          sourceId: "",
          icon: "https://d2dl4lnfba3hk3.cloudfront.net/AllIcon.svg",
        },
        {
          label: "Job Link",
          value: "JobLink",
          sourceId: "",
          icon: "https://d2dl4lnfba3hk3.cloudfront.net/JobLinkIcon1.svg",
        },
        {
          label: "Uploaded",
          value: "Uploaded",
          sourceId: "",
          icon: "https://d2dl4lnfba3hk3.cloudfront.net/downLogo.svg",
        },
      ];

      const updatedData = [
        ...defaultData,
        ...(Array.isArray(res.data.data)
          ? res.data.data.map((item: any) => ({
              label: capitalizeFirstLetter(item?.name),
              value: item?.jobIntegrationId,
              sourceId: item?.jobIntegrationId,
              icon: item?.icon,
            }))
          : []),
      ];
      setSessionStorageItem("sourceList", res?.data?.data);
      setReferenceSourceType(res?.data?.data ?? []);
      setSourceType(updatedData);
    } catch (error) {
      console.error("Error fetching sources list:", error);
    }
  };
  // Get the system cv refresh status
  const handleSystemCvRefresh = async () => {
    const systemCvRefreshRes = await systemCVRefreshStatus(jobId);
    if (systemCvRefreshRes?.status === 200) {
      setRefreshRequired(systemCvRefreshRes?.data?.refreshRequired);
    }
  };
  // file uploading data function
  const handleFilesUploaded = async (files: any, fileNames: any) => {
    const result = files?.map((item: any, index: number) => ({
      fileName: fileNames[index]?.name,
      fileType: fileNames[index]?.name?.split(".")[1],
      fileSize: fileNames[index]?.size,
      filePath: item?.fileName || "",
    }));
    const fileRes = await scanCVs({
      jobId: jobId,
      CVs: result,
    });
    if (fileRes?.status === 200) {
      const uniqueCvData = fileRes?.data?.filter(
        (item: any, index: number, self: any) =>
          index === self.findIndex((t: any) => t?.cvId === item?.cvId),
      );

      setCvScanData(uniqueCvData);
      setFileProgressList([]);
    }
  };
  // function for list of cvs
  const cvListFunData = async (page?: number) => {
    getCVCounts();
    const getSourceListFromSession = getSessionStorageItem("sourceList") ?? [];
    let updateSourceList: any = [];
    if (getSourceListFromSession?.length) {
      updateSourceList = getSourceListFromSession?.filter(
        (item: any) => item?.jobIntegrationId === selectedSourceType,
      );
    } else {
      const res = await getSourcesList(jobId);
      updateSourceList = res?.data?.data?.filter(
        (item: any) => item?.jobIntegrationId === selectedSourceType,
      );
      setSessionStorageItem("sourceList", res?.data?.data ?? []);
    }

    const sourceType =
      jobDetailsTab === JobScreensEnums.TAB_VENDOR
        ? "Vendor"
        : updateSourceList?.length
          ? capitalizeFirstLetter(updateSourceList[0]?.type)
          : capitalizeFirstLetter(selectedSourceType);
    const sourceId =
      jobDetailsTab === JobScreensEnums.TAB_VENDOR
        ? venderTabId
        : updateSourceList[0]?.jobIntegrationId;
    const filterColumns =
      jobDetailsTab === "unscannedcv" ? "uploadedDate" : isfilterColumns;
    const scanStatus =
      cvStatus === "scanned"
        ? "scanned"
        : cvStatus === "all"
          ? JobScreensEnums.STATUS_ALL
          : "unscanned";
    const isInvited = cvStatus === "invited" ? true : false;
    const tabType =
      jobDetailsTab === JobScreensEnums.TAB_APPLICATIONS
        ? "Application"
        : jobDetailsTab === JobScreensEnums.TAB_SELF
          ? "Self"
          : jobDetailsTab === JobScreensEnums.TAB_VENDOR
            ? "Vendor"
            : "";
    const cvListRes = await cvList(
      jobId,
      filterColumns,
      isDirectionArrow,
      searchCvDelay,
      page ?? currentPage,
      pageSize,
      sourceType,
      scanStatus,
      isInvited,
      sourceId ?? "",
      tabType,
    );
    if (cvListRes?.status === 200) {
      // if in progress then set hasInProgress true so that we can run function in every 5 sec until any of the item is inProgress
      setHasInProgress(
        cvListRes?.data?.data?.some(
          (item: any) => item.scanStatus === "inprogress",
        ),
      );
      setCvListData(cvListRes?.data?.data);

      setTotalCvListData(cvListRes?.data?.totalCount);
      setLoadingCvList(false);
    } else {
      setLoadingCvList(false);
    }
  };
  const handleJobAssessmentCreation = async () => {
    const deleteData = await deleteAssessmentTempData(
      localStorage.getItem("companyId") ?? "",
      localStorage.getItem("tempUniqueId") ?? "",
    );
    if (deleteData?.data?.status === 200) {
      sessionStorage.clear();
      localStorage.removeItem("tempUniqueId");
      navigate(
        `/${currentLanguage}/assessment/build/${foundUniqueId()}?jobId=${jobId}`,
        {
          state: {
            jobSkillData: matchedSkills,
            jobTitle: jobDetailsData?.title,
          },
        },
      );
    } else {
      sessionStorage.clear();
      localStorage.removeItem("tempUniqueId");
      navigate(
        `/${currentLanguage}/assessment/build/${foundUniqueId()}?jobId=${jobId}`,
        {
          state: {
            jobSkillData: matchedSkills,
            jobTitle: jobDetailsData?.title,
          },
        },
      );
    }
  };
  const renderContent = (activeTabs?: string) => {
    if (
      jobDetailsTab === JobScreensEnums.TAB_ASSESSMENTS &&
      assessmentDetailsData?.length === 0
    ) {
      return (
        <div className="assessmentNotAvailable">
          <NoAssessmentImage />
          <div className="noAssessmentMsg">
            <span>{t("RESUME.NO_ASSESSMENT_AVAILABLE")}</span> <br />
            <span>{t("RESUME.CLICK_BELOW_BTN")}</span>
          </div>
          <AssessmentButton
            onClick={() => {
              handleJobAssessmentCreation();
            }}
          >
            {t("CREATE_ASSESSMENT.TITLE")}
          </AssessmentButton>
        </div>
      );
    }

    if (activeAssessment) {
      return (
        <AssessmentsDetails
          jobId={jobId}
          assessmentData={activeAssessmentData}
        />
      );
    }
    switch (activeTabs) {
      case JobScreensEnums.TAB_SELF:
      case JobScreensEnums.TAB_APPLICATIONS:
      case JobScreensEnums.TAB_VENDOR:
        return (
          <TabsFilter
            tabActive={jobDetailsTab}
            jobId={jobId}
            handleFilesUploaded={handleFilesUploaded}
            fileUploadData={cvScanData}
            setFileProgressList={setFileProgressList}
            fileProgressList={fileProgressList}
            isConfirmScanCvs={isConfirmScanCvs}
            isAssessmentAvailable={assessmentDetailsData}
            selectedSourceType={selectedSourceType}
            setSelectedSourceType={setSelectedSourceType}
            isfilterColumns={isfilterColumns}
            setIsFilterColumns={setIsFilterColumns}
            isDirectionArrow={isDirectionArrow}
            setIsDirectionArrow={setIsDirectionArrow}
            setSearchCv={setSearchCv}
            searchCv={searchCv}
            setCurrentPage={setCurrentPage}
            currentPage={currentPage}
            searchCvDelay={searchCvDelay}
            cvListData={cvListData}
            totalCvListData={totalCvListData}
            setPageSize={setPageSize}
            pageSize={pageSize}
            setLoading={setLoading}
            loading={loading}
            setSourceType={setSourceType}
            sourceType={sourceType}
            cvListFunData={cvListFunData}
            referenceSourceType={referenceSourceType}
            updateCountFunc={getCVCounts}
            loadingCvList={loadingCvList}
            hasInProgress={hasInProgress}
            isInvited={isInvitedPopup}
            setIsInvited={setIsInvitedPopup}
            scoreCalculationSideBar={scoreCalculationSideBar}
            setScoreCalculationSideBar={setScoreCalculationSideBar}
            cvStatus={cvStatus}
            setCvStatus={setCvStatus}
            jobTitle={jobDetailsData?.title}
            isSourceTypeFilterVisible={
              jobDetailsTab === JobScreensEnums.TAB_SELF
            }
            venderTabId={venderTabId}
            contractDocPopup={contractDocPopup}
            setContractDocPopup={setContractDocPopup}
            showDocument={showDocument}
            setShowDocument={setShowDocument}
          />
        );
      case JobScreensEnums.TAB_JOB_DETAILS:
        return <JobDetails jobData={jobDetailsData} />;
      case JobScreensEnums.TAB_SOURCE:
        return (
          <SourceList
            refreshRequired={refreshRequired}
            getCVCounts={getCVCounts}
            sourcesListApi={getSourcesListApi}
          />
        );
      case JobScreensEnums.TAB_ASSESSMENTS:
        return <AssessmentsDetails jobId={jobId} />;
      case JobScreensEnums.TAB_VENDORS:
        return (
          <Vendors
            isInviteVendorOpen={isInviteVendorOpen}
            setIsInviteVendorOpen={setIsInviteVendorOpen}
            refreshSidebarVendors={() => {}}
            setVendorTabId={setVenderTabId}
            setJobDetailsTab={setJobDetailsTab}
            totalCvListData={totalCvListData}
            vendorCvCounts={cvCounts?.vendorsCVs}
          />
        );
      default:
        return null;
    }
  };
  return (
    <DetailsPageWrapper
      jobDetails={jobDetailsData}
      onFilesUploaded={handleFilesUploaded}
      fileUploadData={cvScanData}
      setFileProgressList={setFileProgressList}
      fileProgressList={fileProgressList}
    >
      <div className="d-flex flex-wrap">
        <div className="col-sm-12 col-md-3 col-lg-2 sideBarContent">
          {/* Sidebar */}
          <div className="sidebar">
            {/* job details */}
            <div
              className={`tab ${jobDetailsTab === JobScreensEnums.TAB_JOB_DETAILS ? "active" : ""}`}
              onClick={() => {
                handleActiveTab(JobScreensEnums.TAB_JOB_DETAILS);
                setActiveAssessment(null);
              }}
            >
              <div className="iconJobText">
                <CvJobDetailsIcon />
                <h6>{t("RESUME.SCANNING_JOB_DETAILS")}</h6>
              </div>
            </div>
            {/* assessment */}
            <div className="assessmentList">
              <div
                className={`tab ${assessmentDetailsData.length === 0 ? (jobDetailsTab === JobScreensEnums.TAB_ASSESSMENTS ? "active clickable" : "clickable") : "noHover"}`}
                onClick={() => {
                  if (assessmentDetailsData.length === 0) {
                    handleActiveTab(JobScreensEnums.TAB_ASSESSMENTS);
                    setActiveAssessment(null);
                    setActiveAssessmentData({});
                  }
                }}
              >
                <div className="iconText">
                  <CvAssessmentTabIcon />
                  <h6>{t("RESUME.SCANNING_ASSESSMENTS")}</h6>
                </div>
              </div>
              {assessmentDetailsData.length > 0 &&
                assessmentDetailsData?.map((assessment: any, ind: number) => (
                  <div
                    key={ind}
                    title={assessment?.title}
                    className={`tab ${activeAssessment === assessment?.assessmentId ? "active" : ""}`}
                    onClick={() => {
                      setActiveAssessment(assessment?.assessmentId);
                      setActiveAssessmentData(assessment);
                      handleActiveTab(JobScreensEnums.TAB_ASSESSMENTS);
                    }}
                  >
                    <div className="subAsessment">
                      <div className="assessmentTitle">
                        <h6>{assessment?.title}</h6>
                      </div>
                    </div>
                  </div>
                ))}
            </div>
            {/* source */}
            <div className="assessmentList">
              <div
                className={`tab ${jobDetailsTab === JobScreensEnums.TAB_SOURCE ? "active" : ""}`}
                onClick={() => {
                  handleActiveTab(JobScreensEnums.TAB_SOURCE);
                  setActiveAssessment(null);
                  setActiveAssessmentData({});
                }}
              >
                <div className="iconText">
                  <CvSourceIcon />
                  <h6>{t("RESUME.SCANNING_SOURCING")}</h6>
                </div>
              </div>
            </div>
            {/* Vendors */}
            {isStaffAugEnabled && (
              <div className="assessmentList">
                <div
                  className={`tab ${jobDetailsTab === JobScreensEnums.TAB_VENDORS ? "active" : ""}`}
                  onClick={() => {
                    handleActiveTab(JobScreensEnums.TAB_VENDORS);
                    setActiveAssessment(null);
                    setActiveAssessmentData({});
                    setIsInviteVendorOpen(false);
                  }}
                >
                  <div className="iconText">
                    <VendorsIcon />
                    <h6>{t("RESUME.VENDORS")}</h6>
                  </div>
                </div>
              </div>
            )}
            {/* Application  */}
            <div
              onMouseEnter={() => setShowSortMenu(true)}
              onMouseLeave={() => setShowSortMenu(false)}
              className={`tab ${jobDetailsTab === JobScreensEnums.TAB_APPLICATIONS ? "active" : ""}`}
              onClick={() => {
                setLoadingCvList(true);
                handleActiveTab(JobScreensEnums.TAB_APPLICATIONS);
                setActiveAssessment(null);
                setActiveAssessmentData({});
                setSelectedSourceType(JobScreensEnums.STATUS_ALL);
                setIsFilterColumns("overAll");
                setIsDirectionArrow("desc");
                setSearchCv("");
                setCurrentPage(1);
                scrollWindowTop();
                setCvStatus("all");
              }}
            >
              <div className="iconJobText">
                <CvIcon />
                <div className="applicationTab">
                  <h6>{t("RESUME.APPLICATIONS")}</h6>
                  {showSortMenu ? (
                    <div
                      className="applicationMoreIcon"
                      onClick={(e) => {
                        e.stopPropagation();
                        setShowOverlay((prev) => !prev);
                      }}
                    >
                      <MoreIcon />
                      <div
                        className={`overlayBox ${showOverlay ? "open" : "closed"}`}
                        ref={overlayRef}
                      >
                        <div
                          className="filterOption"
                          onClick={() => {
                            setVendorSortBy("vendorName");
                            setVendorSortOrder("asc");
                          }}
                        >
                          {t("RESUME.SORT_AZ")}
                        </div>
                        <div
                          className="filterOption"
                          onClick={() => {
                            setVendorSortBy("vendorName");
                            setVendorSortOrder("desc");
                          }}
                        >
                          {t("RESUME.SORT_ZA")}
                        </div>
                        <div
                          className="filterOption"
                          onClick={() => {
                            setVendorSortBy("cvCount");
                            setVendorSortOrder("desc");
                          }}
                        >
                          {t("RESUME.SORT_MAXIMUM_PROFILES")}
                        </div>
                        {/* <div className="filterOption">
                          {t("RESUME.SORT_NEAR_BY")}
                        </div> */}
                      </div>
                    </div>
                  ) : (
                    <span className="countCircle">{cvCounts?.allCVCount}</span>
                  )}
                </div>
              </div>
            </div>

            <div className="tabs">
              <div
                className={`tab ${jobDetailsTab === JobScreensEnums.TAB_SELF ? "active" : ""}`}
                onClick={() => {
                  setLoadingCvList(true);
                  handleActiveTab(JobScreensEnums.TAB_SELF);
                  setActiveAssessment(null);
                  setActiveAssessmentData({});
                  setSelectedSourceType(JobScreensEnums.STATUS_ALL);
                  setIsFilterColumns("overAll");
                  setIsDirectionArrow("desc");
                  setSearchCv("");
                  setCurrentPage(1);
                  scrollWindowTop();
                  setCvStatus("all");
                }}
              >
                <div className="subTabs">
                  <SelfIcon />
                  <div className="sourceSubTab">
                    <h6>{t("RESUME.SELF")}</h6>
                    <span className="countCircle">{cvCounts?.selfCVCount}</span>
                  </div>
                </div>
              </div>
            </div>
            {/* Vendor List */}
            <div className="assessmentList vendorsLIst">
              {jobPartners?.map((partner: any, index: number) => {
                return (
                  <div
                    title={partner?.partnerUserName && partner?.partnerUserName}
                    key={index}
                    className={`tab ${jobDetailsTab === JobScreensEnums.TAB_VENDOR && venderTabId === partner?.partnerUserId ? "active" : ""}`}
                    onClick={() => {
                      setVenderTabId(partner?.partnerUserId);
                      setLoadingCvList(true);
                      handleActiveTab(JobScreensEnums.TAB_VENDOR);
                      setActiveAssessment(null);
                      setActiveAssessmentData({});
                      setSelectedSourceType(JobScreensEnums.STATUS_ALL);
                      setIsFilterColumns("overAll");
                      setIsDirectionArrow("desc");
                      setSearchCv("");
                      setCurrentPage(1);
                      scrollWindowTop();
                      setCvStatus("all");
                    }}
                  >
                    <div className="subAsessment">
                      <div className="assessmentTitle">
                        <img src={partner?.companyLogo} alt="" />
                        <h6>{partner?.partnerUserName || "-"}</h6>
                        <span className="countCircle">{partner?.cvCount}</span>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
        <div className="col-sm-12 col-md-9 col-lg-10 d-flex flex-column rightPortion">
          {/* Content Area */}
          {cvCountLoader ? (
            <JobCvList />
          ) : (
            <div className="content-area">{renderContent(jobDetailsTab)}</div>
          )}
        </div>
        {(cvScanData || fileProgressList) &&
        (cvScanData?.length || fileProgressList?.length) ? (
          <UploadFilePopup
            jobId={jobId}
            fileUploadData={cvScanData}
            setCvScanData={setCvScanData}
            fileProgressList={fileProgressList}
            setIsConfirmScanCvs={setIsConfirmScanCvs}
            getCVCounts={getCVCounts}
          />
        ) : null}
      </div>
    </DetailsPageWrapper>
  );
};

export default SideBarTabContent;
